import { useQuery } from '@tanstack/react-query'

import { getEvidenceImage } from '@src/api'
import { DefaultApiGetEvidenceImageRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchEvidenceImage = (
  params: DefaultApiGetEvidenceImageRequest
) => {
  const { axiosInstance } = useAxios()
  axiosInstance.defaults.responseType = 'arraybuffer'

  return useQuery({
    enabled:
      !!params.organizationId &&
      !!params.paymentReferenceId &&
      !!params.cardTransactionEvidenceId,
    queryFn: () => getEvidenceImage(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_EVIDENCE_IMAGE,
      params.organizationId,
      params.paymentReferenceId,
      params.cardTransactionEvidenceId,
    ],
  })
}
